import { useApi } from '@gravitate-js/the-armory'
import { useMutation } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
export const useTractors = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const updateTractorMutation = () =>
    useMutation({
      mutationKey: ['updateTractor'],
      mutationFn: (tractor: Tractor) => {
        if (tractor?.tractor_number) tractor.tractor_number = tractor.tractor_number.toString()
        return api.post('tractor/update', tractor)
      },
    })

  return { updateTractorMutation }
}

interface Tractor {
  extra_data: {}
  updated_on: Date
  tractor_number: string | number
  depot: string
  vin: string
  make: string
  model: string
  year: number
  weight: number
  next_tractor_maintenance_required: boolean
  id: string
  key: string
}
